"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard"),
    _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends")),
    _react = _interopRequireWildcard(require("react")),
    _commentsContext = _interopRequireDefault(require("../../../../../contexts/commentsContext")),
    _Indicators = _interopRequireDefault(require("../components/Indicators"));

function Indicators(a) {
  var b = a.comments;
  return _react["default"].createElement(_commentsContext["default"].Consumer, null, function (c) {
    var d = c.state.userAssignedColors;
    return _react["default"].createElement(_Indicators["default"], (0, _extends2["default"])({}, a, {
      comments: b,
      userAssignedColors: d
    }));
  });
}

var _default = (0, _react.memo)(Indicators);

exports["default"] = _default;